<!-- ELIMINAR ESTE COMPONENTE EL 3 DE OCTUBRE -->
<div class="container-warn">
  <div>
    <span class="content">
      <strong>Cuentas comerciales:</strong> Desde el lunes 3/10/2022 al loguearte te pediremos ingresar un código que te llegará vía email. <strong>Trabajamos para maximizar tu seguridad.</strong>
    </span>
  </div>
  <div>
    <button (click)="navigate()">ver más</button>
  </div>
</div>
